/**
 * Created by Mikhail Menshenin on 09.07.2024
 */

ExitControlButton.isAvailableOnScene = function () {
    return false;
};
